import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import style from "./style";
import { ReactComponent as Print } from "../../../../../assets/ViewLeave-images/print.svg";
// import { useNavigate } from "react-router-dom";
import CustomInput from "../../../../../components/CustomInput";
import { useForm } from "../../../../../hooks/useForm";
import { getTaxLabel, getVisibleTaxSetting } from "../../../../../utils/payslipSettings";
import { payslipData } from "../../../../../constants/data";
import { ItemsValidates } from "../../../../../helper/Validation";
import Modal from "../../../../../components/Modal";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, FormControlLabel, Checkbox, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { formatDate } from "../../../../../utils/DateFormat";


const SalaryEdit = ({ getLoanList, getLeave, leaveData, getDeductionList, deductionData, loanData, handleUpdate, loading, data, getAllowanceList,
  getLevieList, allowanceData, levieData, getFringeList, fringeData, payslip,handleSalaryReport, getContribution, contribution }) => {
  const [pensionOpen, setPensionOpen] = useState(false)
  const [allowanceOpen, setAllowanceOpen] = useState(false)
  const [levieOpen, setLevieOpen] = useState(false)
  const [fringeOpen, setFringeOpen] = useState(false)
  const [loanOpen, setLoanOpen] = useState(false)
  const [leaveOpen, setLeaveOpen] = useState(false)
  const [deductionOpen, setDeductionOpen] = useState(false)
  const [travelValue, setTravelValue] = useState()
  const [calculatedTotal, setCalculatedTotal] = useState();
  const [edit, setEdit] = useState(false)
  const [calculatedTotalWorking,setCalculatedTotalWorking] = useState();

  const handleChanges = (value) => {
    const rateRembTravel = data?.employee?.salaryInfo?.rateRembTravel || 0;

    // Update travel value
    const kmTotal = Math.max(0, Number(value)); 
    setTravelValue(kmTotal);
    setEdit(true)
    // Calculate the total directly
    const total = Math.max(0, kmTotal * rateRembTravel);
    setCalculatedTotal(total);
  };

  const handleData = (user) => {
    handleUpdate(user,travelValue);
  }
  const handleLeave = () => {
    getLeave(data?.employee?._id);
    setLeaveOpen(true)
  }
  const handlePension = () => {
    getContribution();
    setPensionOpen(true)

  };
  const handleLoan = () => {
    getLoanList();
    setLoanOpen(true)

  };

  const handleDeduction = () => {
    getDeductionList();
    setDeductionOpen(true)

  };

  const handleAllowance = () => {
    getAllowanceList();
    setAllowanceOpen(true)

  };
  const handleFringe = () => {
    getFringeList();
    setFringeOpen(true)

  };
  const handleLevie = () => {
    getLevieList();
    setLevieOpen(true)

  };

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    payslipData,
    ItemsValidates,
    handleData,
  );
  const { employeeName, employeeNumber, salaryPHr, restraintTrade, reimbursiveRate, allowances, commission, taxable, totalTax,
    fringeBenefit, allDeductions, loanRepayment, uif, employerLevies, leave, grossIncome, totalDeductions, nettPay, payable, isShow
  } = state;

  // UIF/SDL rows follow the country-driven /payslip_settings list; labels come from the backend.
  const uifSetting = getVisibleTaxSetting(payslip, "UIF");
  const sdlSetting = getVisibleTaxSetting(payslip, "SDL");

  const handleChangesWorking = (value) => {
    const calHourlySalary = data?.calHourlySalary?.calHourlySalary || 0;
    // setTravelValueWorking(value);
    const totalWorking = Number(value) * calHourlySalary;
    setCalculatedTotalWorking(totalWorking)
  };

  return (
    <>

      {/* {loading && <CircularIndeterminate />} */}

      <Box sx={style.mainContainer}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Salary Edit</Typography>
        </Box>
        <Box>
          <FormControlLabel
            sx={style.formControlLabel}
            control={
              <Checkbox
                defaultChecked={data?.isShowEmpty}
              />
            }
            checked={isShow?.value}
            onChange={(e) =>{
              setEdit(true)
              handleChange("isShow", e.target.checked)              
            }}
            label="Show Empty Value"
          />


          <Button variant="contained" sx={style.printbtn} onClick={() => handleSalaryReport()}>
            <Box sx={style.downloadIcon}>
              <Print />
            </Box>
            Print
          </Button>
        </Box>
      </Box>
      <form onSubmit={(e) => {
        handleSubmit(e)
      }}>

        <Grid container>
          <Grid item xs={12} lg={11.6} sx={style.gridbox}>
            <Box sx={style.inputSections}>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Employee Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={true}
                  id="employeeName"
                  error={employeeName?.error}
                  name="employeeName"
                  defaultValue={data?.fullName}

                  onChange={() => {
                    setEdit(true)
                    handleChange()
                  }}
                  onFocus={handleFocus}
                  autoComplete="employeeName" />
              </Box>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Staff Id</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="employeeNumber"
                  error={employeeNumber?.error}
                  name="employeeNumber"
                  defaultValue={data?.employee?.stafId ?? 0}
                  readOnly={true}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeNumber" />
              </Box>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Company Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={true}
                  id="employeeName"
                  error={employeeName?.error}
                  name="employeeName"
                  defaultValue={data?.company?.companyName}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeName" />
              </Box>

            </Box>

            <Box sx={style.inputSections}>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Payslip Number</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={true}
                  id="employeeName"
                  error={employeeName?.error}
                  name="employeeName"
                  defaultValue={data?.payslipNumber}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeName" />
              </Box>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}> Payroll Frequency</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="employeeNumber"
                  error={employeeNumber?.error}
                  name="employeeNumber"
                  defaultValue={data?.frequency}
                  readOnly={true}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeNumber" />
              </Box>
              <Box sx={style.inputBoxes}>
              </Box>


            </Box>

          </Grid>


        </Grid>

        <Grid container>
          <Grid item xs={12} lg={7.4}>
            <Grid container>


              <Grid item xs={12} lg={12} sx={style.gridbox}>

                <>
                  <Box sx={style.lineTextGrid}>
                    <Box sx={style.permissionLine}></Box>
                    <Box><Typography sx={style.gridText}>Salary</Typography></Box>
                  </Box>

                  <Box sx={style.inputSection}>
                    <Box sx={style.inputBox}>
                      <Typography sx={style.inputText}>Salary</Typography>
                      {data?.isShowEmpty || data?.employee?.salaryInfo?.salary !== 0 ? (


                        <CustomInput
                          variant="outlined"
                          required
                          fullWidth
                          id="salaryPHr"
                          readOnly={true}

                          error={salaryPHr?.error}
                          name="salaryPHr"
                          defaultValue={data?.employee?.salaryInfo?.salary ?? 0}

                          onChange={handleChange}
                          onFocus={handleFocus}

                          autoComplete="salaryPHr" />
                      ) : (
                        <Typography sx={style.noDataText}>No data</Typography>
                      )}

                    </Box>
                    <Box sx={style.inputBox}>
                      <Typography sx={style.inputText}>Restraint of Trade</Typography>
                      {data?.isShowEmpty || data?.employee?.salaryInfo?.restraintTrade !== 0 ? (
                        <CustomInput
                          variant="outlined"
                          required
                          fullWidth
                          readOnly={true}
                          id="restraintTrade"
                          error={restraintTrade?.error}
                          name="restraintTrade"
                          defaultValue={data?.employee?.salaryInfo?.restraintTrade ?? 0}

                          onChange={handleChange}
                          onFocus={handleFocus}
                          autoComplete="restraintTrade" />
                      ) : (
                        <Typography sx={style.noDataText}>No data</Typography>
                      )}

                    </Box>

                  </Box>
                </>

                {data?.employee?.salaryInfo?.hRate === "Hourly" && (
                  <Box sx={{ ...style.inputSection1, paddingTop: "15px" }}>
                
                    <Box sx={style.inputBoxRate}>
                      <Typography sx={style.inputText}>Working Rate</Typography>
                      <Box sx={style.inputBox}>
                        <TextField
                          variant="outlined"
                          required
                          fullWidth
                          // type="Number"
                          name="reimbursiveTravel"
                          // onChange={(e) => { handleChangesWorking(e?.target?.value) }}
                          // value={travelValueWorking}
                          value={data?.rate ?? 0}
                
                        />
                      </Box>
                    </Box>
                
                    <Box sx={{ paddingTop: "35px" }}>
                      <Box sx={style.crossIcon}>X</Box>
                    </Box>
                
                    <Box sx={style.inputBoxRate}>
                      <Typography sx={style.inputText}>Working Hours</Typography>
                      <Box sx={style.inputBox}>
                        <TextField
                          variant="outlined"
                          required
                          fullWidth
                          disabled
                          id="reimbursiveRate"
                          error={reimbursiveRate?.error}
                          readOnly={true}
                          // type="Number"
                          name="reimbursiveRate"
                          onChange={handleChangesWorking}
                          onFocus={handleFocus}
                          value={data?.normalHours ?? 0}
                          autoComplete="reimbursiveRate" 
                          InputProps={{
                            style: {
                              color: "black",
                            },
                          }}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "black",
                              color: "black",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                
                    <Box sx={{ paddingTop: "35px" }}>
                      <Box sx={style.crossIcon}>=</Box>
                    </Box>
                
                    <Box sx={style.inputBoxRate}>
                      <Typography sx={style.inputText}>Total Working Amount</Typography>
                      <Box sx={style.inputBox}>
                        <TextField
                          type="Number"
                          name="totalTravel"
                          value={calculatedTotalWorking}
                          // defaultValue="0"
                          disabled
                          defaultValue={data?.calHourlySalary}
                          InputProps={{
                            style: {
                              color: "black",
                            },
                          }}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "black",
                              color: "black",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                
                  </Box>
                )}


                <Box sx={style.inputSection}>

                  <Box sx={style.inputBoxRate}>
                    <Typography sx={style.inputText}>Reimbursive travel (Business km x Rate)</Typography>
                    <Box sx={style.inputBox}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        type="Number"
                        name="reimbursiveTravel"
                        onChange={(e) => {handleChanges(e?.target?.value)}}
                        value={travelValue}
                        defaultValue={data?.kilometer}
                        placeholder={data?.kilometer}
                        InputProps={{
                          inputProps: {
                            style: { color: "black" },
                          }
                        }}
                        sx={{
                          "& input::placeholder": {
                            color: "black",
                            opacity: 1,
                          },
                        }}

                      />
                      <Box sx={style.crossIcon}>X</Box>
                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="reimbursiveRate"
                        error={reimbursiveRate?.error}
                        readOnly={true}
                        type="Number"
                        name="reimbursiveRate"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.employee?.salaryInfo?.rateRembTravel ?? 0}
                        autoComplete="reimbursiveRate" />
                      <Box sx={style.crossIcon}>=</Box>
                      <TextField
                        type="Number"
                        name="totalTravel"
                        value={calculatedTotal}
                        disabled
                        defaultValue={data?.totalRemb ?? 0 }
                        InputProps={{
                          style: {
                            color: "black", // Text color for disabled state
                          },
                        }}
                        sx={{
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "black", // For Chrome and WebKit-based browsers
                            color: "black", // Fallback for other browsers
                          },
                        }}
                      />


                    </Box>

                  </Box>

                </Box>


                {uifSetting && data?.uif > 0 && (
                  <>
                    <Box sx={style.greyLine}></Box>

                    <Box sx={style.lineTextGrid}>
                      <Box sx={style.permissionLine}></Box>
                      <Box><Typography sx={style.gridText}> {getTaxLabel(uifSetting)}</Typography></Box>
                    </Box>


                    <Box sx={style.inputSection}>

                      <Box sx={style.inputBox}>
                        <Typography sx={style.inputText}> {getTaxLabel(uifSetting)}</Typography>
                        <CustomInput
                          variant="outlined"
                          required
                          fullWidth
                          id="uif"
                          error={uif?.error}
                          name="uif"
                          onChange={handleChange}
                          onFocus={handleFocus}
                          defaultValue={data?.uif ?? 0}
                          // readOnly={true}
                          value={uif?.value}

                          autoComplete="uif" />

                      </Box>

                    </Box>


                  </>

                )}

                {sdlSetting && data?.sdl > 0 && (
                  <>

                    <Box sx={style.greyLine}></Box>

                    <Box sx={style.lineTextGrid}>
                      <Box sx={style.permissionLine}></Box>
                      <Box><Typography sx={style.gridText}>{getTaxLabel(sdlSetting)}</Typography></Box>
                    </Box>


                    <Box sx={style.inputSection}>

                      <Box sx={style.inputBox}>
                        <Typography sx={style.inputText}>{getTaxLabel(sdlSetting)}</Typography>
                        <CustomInput
                          variant="outlined"
                          required
                          fullWidth
                          id="sdl"
                          error={uif?.error}
                          name="sdl"
                          onChange={handleChange}
                          onFocus={handleFocus}
                          defaultValue={data?.sdl ?? 0}
                          readOnly={true}

                          autoComplete="uif" />

                      </Box>

                    </Box>


                  </>

                )}



                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Tax</Typography></Box>
                </Box>

                <Box sx={style.inputSection}>

                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Tax Rate</Typography>
                    {data?.isShowEmpty || data?.taxRate !== 0 ? (
                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="taxable"
                        error={taxable?.error}
                        name="taxable"
                        readOnly={true}
                        defaultValue={data?.taxRate ?? 0}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        autoComplete="taxable" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>


                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Total Tax</Typography>
                    {data?.isShowEmpty || data?.totalTax !== 0 ? (
                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="totalTax"
                        error={totalTax?.error}
                        type="Number"
                        name="totalTax"
                        defaultValue={data?.totalTax ?? 0}
                        readOnly={true}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        autoComplete="totalTax" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>



                  {/* <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Net Tax</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="netTax"
                      error={totalTax?.error}
                      type="Number"
                      name="netTax"
                      defaultValue={data?.totalTax ?? 0}
                      value={netTax?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="totalTax" />
                  </Box> */}


                </Box>

                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Overtime</Typography></Box>
                </Box>

                <Box sx={style.inputSection}>

                  <Box sx={style.inputBox}>

                    {/* {data?.employee?.salaryInfo?.hRate === "Salary" && (
                      <>
                        <Typography sx={style.inputText}>Overtime</Typography>
                        {data?.isShowEmpty || data?.overTime !== 0 ? (

                          <CustomInput
                            variant="outlined"
                            required
                            fullWidth
                            id="overtime"
                            error={overtime?.error}
                            name="overtime"
                            readOnly={true}
                            defaultValue={data?.overTime ?? 0}
                            onChange={handleChange}
                            onFocus={handleFocus}

                            autoComplete="taxable" />
                        ) : (
                          <Typography sx={style.noDataText}>No Data</Typography>
                        )}
                      </>
                    )} */}

                  </Box>
                  { (
                    <Box sx={style.inputSection1}>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>OverTime Rates</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            fullWidth
                            // type="Number"
                            name="reimbursiveTravel"
                            // onChange={(e) => { handleChanges(e?.target?.value) }}
                            // value={travelValue}
                            value={data?.employee?.additionalInformation?.overTimeRate ?? 0}

                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>X</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Rate</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            disabled
                            fullWidth
                            id="reimbursiveRate"
                            error={reimbursiveRate?.error}
                            readOnly={true}
                            // type="Number"
                            name="reimbursiveRate"
                            onChange={handleChange}
                            // onFocus={handleFocus}
                            value={data?.rate ?? 0}
                            autoComplete="reimbursiveRate" 
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>X</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>OverTime Hours</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            disabled
                            fullWidth
                            id="reimbursiveRate"
                            error={reimbursiveRate?.error}
                            readOnly={true}
                            // type="Number"
                            name="reimbursiveRate"
                            onChange={handleChange}
                            // onFocus={handleFocus}
                            value={data?.overtimeHours ?? 0}
                            autoComplete="reimbursiveRate" 
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>=</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Total OverTime</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            type="Number"
                            name="totalTravel"
                            value={calculatedTotalWorking}
                            // defaultValue="0"
                            disabled
                            defaultValue={data?.overTime}
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                    </Box>
                  )}


                  <Box sx={style.inputBox}>

                    {/* {data?.employee?.salaryInfo?.hRate === "Salary" && (
                      <>
                        <Typography sx={style.inputText}>Double Overtime</Typography>

                        {data?.isShowEmpty || data?.doubleOverTime !== 0 ? (

                          <CustomInput
                            variant="outlined"
                            required
                            fullWidth
                            id="doubleOvertime"
                            error={overtime?.error}
                            type="Number"
                            name="doubleOvertime"
                            defaultValue={data?.doubleOverTime ?? 0}
                            readOnly={true}
                            onChange={handleChange}
                            onFocus={handleFocus}
                            autoComplete="totalTax" />
                        ) : (
                          <Typography sx={style.noDataText}>No Data</Typography>
                        )}
                      </>
                    )} */}

                  </Box>
                  {(
                    <Box sx={style.inputSection1}>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Double Overtime Rates</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            fullWidth
                            // type="Number"
                            name="reimbursiveTravel"
                            // onChange={(e) => { handleChanges(e?.target?.value) }}
                            // value={travelValue}
                            value={data?.employee?.additionalInformation?.doubleOverTimeRate ?? 0}

                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>X</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Rate</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            disabled
                            fullWidth
                            id="reimbursiveRate"
                            error={reimbursiveRate?.error}
                            readOnly={true}
                            // type="Number"
                            name="reimbursiveRate"
                            onChange={handleChange}
                            // onFocus={handleFocus}
                            value={data?.rate ?? 0}
                            autoComplete="reimbursiveRate" 
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black", 
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>X</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Double Overtime Hours</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            disabled
                            fullWidth
                            id="reimbursiveRate"
                            error={reimbursiveRate?.error}
                            readOnly={true}
                            // type="Number"
                            name="reimbursiveRate"
                            onChange={handleChange}
                            // onFocus={handleFocus}
                            value={data?.doubleOvertimeHours ?? 0}
                            autoComplete="reimbursiveRate" 
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>=</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Total Double Overtime</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            type="Number"
                            name="totalTravel"
                            value={calculatedTotalWorking}
                            // defaultValue="0"
                            disabled
                            defaultValue={data?.doubleOverTime}
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                    </Box>
                  )}

                  <Box sx={style.inputBox}>

                    {/* {data?.employee?.salaryInfo?.hRate === "Salary" && (
                      <>
                        <Typography sx={style.inputText}>Extratime</Typography>

                        {data?.isShowEmpty || data?.extraTime !== 0 ? (

                          <CustomInput
                            variant="outlined"
                            required
                            fullWidth
                            id="doubleOvertime"
                            error={overtime?.error}
                            type="Number"
                            name="doubleOvertime"
                            defaultValue={data?.extraTime ?? 0}
                            readOnly={true}
                            onChange={handleChange}
                            onFocus={handleFocus}
                            autoComplete="totalTax" />
                        ) : (
                          <Typography sx={style.noDataText}>No Data</Typography>
                        )}
                      </>
                    )} */}

                  </Box>
                  {(
                    <Box sx={style.inputSection1}>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Extratime Rates</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            fullWidth
                            // type="Number"
                            name="reimbursiveTravel"
                            // onChange={(e) => { handleChanges(e?.target?.value) }}
                            // value={travelValue}
                            value={data?.employee?.additionalInformation?.extraTimeRate ?? 0}

                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>X</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Rate</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            disabled
                            fullWidth
                            id="reimbursiveRate"
                            error={reimbursiveRate?.error}
                            readOnly={true}
                            // type="Number"
                            name="reimbursiveRate"
                            onChange={handleChange}
                            // onFocus={handleFocus}
                            value={data?.rate ?? 0}
                            autoComplete="reimbursiveRate" 
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>X</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Extratime Hours</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            variant="outlined"
                            required
                            disabled
                            fullWidth
                            id="reimbursiveRate"
                            error={reimbursiveRate?.error}
                            readOnly={true}
                            // type="Number"
                            name="reimbursiveRate"
                            onChange={handleChange}
                            // onFocus={handleFocus}
                            value={data?.extratimeHours ?? 0}
                            autoComplete="reimbursiveRate"
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      <Box sx={{ paddingTop: "35px" }}>
                        <Box sx={style.crossIcon}>=</Box>
                      </Box>

                      <Box sx={style.inputBoxRate}>
                        <Typography sx={style.inputText}>Total Extratime</Typography>
                        <Box sx={style.inputBox}>
                          <TextField
                            type="Number"
                            name="totalTravel"
                            value={calculatedTotalWorking}
                            // defaultValue="0"
                            disabled
                            defaultValue={data?.extraTime}
                            InputProps={{
                              style: {
                                color: "black",
                              },
                            }}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "black",
                                color: "black",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                    </Box>
                  )}

                </Box>

                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Nett Pay </Typography></Box>
                </Box>

                <Box sx={style.inputSection}>

                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Nett Pay</Typography>
                    {data?.isShowEmpty || data?.netPay !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="nettPay"
                        error={nettPay?.error}
                        name="nettPay"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.netPay || 0}
                        readOnly={true}

                        autoComplete="nettPay" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>



                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Payable</Typography>
                    {data?.isShowEmpty || data?.payable !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="payable"
                        error={payable?.error}
                        name="payable"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.payable ?? 0}
                        readOnly={true}
                        autoComplete="payable" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>



                </Box>

                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Absent</Typography></Box>
                </Box>
                <Box sx={style.inputSection}>

                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Absent</Typography>
                    {data?.isShowEmpty || data?.netPay !== 0 ? (
                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="nettPay"
                        error={nettPay?.error}
                        name="nettPay"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.attendanceDeduction}
                        readOnly={true}
                        autoComplete="nettPay" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}


                  </Box>


                </Box>

                <Box sx={style.greyLine}></Box>


                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Income</Typography></Box>
                </Box>


                <Box sx={style.inputSection}>

                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Gross Income</Typography>
                    {data?.isShowEmpty || data?.grossInc !== 0 ? (
                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="grossIncome"
                        error={grossIncome?.error}
                        name="grossIncome"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.grossInc ?? 0}
                        readOnly={true}
                        autoComplete="grossIncome" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>





                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Total Deductions</Typography>
                    {data?.isShowEmpty || data?.totalDeductions !== 0 ? (
                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="totalDeductions"
                        error={totalDeductions?.error}
                        name="totalDeductions"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.totalDeductions ?? 0}
                        readOnly={true}
                        autoComplete="totalDeductions" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>



                </Box>
              </Grid>

            </Grid>
          </Grid>
          <Grid item xs={12} lg={4.4}>
            <Grid container>


              <Grid item xs={12} lg={12} sx={style.gridbox}>
                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Deductions</Typography></Box>
                </Box>
                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>All Deductions</Typography>
                    {data?.isShowEmpty || data?.totalDeductions !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="allDeductions"
                        error={allDeductions?.error}
                        name="allDeductions"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        buttonText="View"
                        readOnly={true}
                        handleView={handleDeduction}

                        defaultValue={data?.totalDeductions || 0}
                        autoComplete="allDeductions" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}


                  </Box>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Loan Repayment</Typography>
                    {data?.isShowEmpty || data?.totalLoan !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="loanRepayment"
                        error={loanRepayment?.error}
                        name="loanRepayment"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        buttonText="View"
                        readOnly={true}
                        handleView={handleLoan}

                        defaultValue={data?.totalLoan || 0}

                        autoComplete="loanRepayment" />

                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>

                </Box>
                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Allowance</Typography></Box>
                </Box>



                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Allowances</Typography>
                    {data?.isShowEmpty || data?.totalAllowance !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="allowances"
                        readOnly={true}

                        error={allowances?.error}
                        name="allowances"
                        onChange={handleChange}
                        buttonText="View"
                        onFocus={handleFocus}
                        defaultValue={data?.totalAllowance || 0}
                        handleView={handleAllowance}

                        autoComplete="allowances" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Commission</Typography>
                    {data?.isShowEmpty || data?.commission !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="commission"
                        error={commission?.error}
                        type="Number"
                        value={commission?.value}
                        name="commission"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.commission ?? 0}
                        autoComplete="commission" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}
                  </Box>

                </Box>
                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Contribution</Typography></Box>
                </Box>
                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Contribution</Typography>
                    {data?.isShowEmpty || data?.totalContribution !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        readOnly={true}
                        error={commission?.error}
                        type="Number"
                        id="contributionCompany"
                        // error={contributionCompany?.error}
                        name="contributionCompany"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        buttonText="View"
                        defaultValue={data?.totalContribution || 0}

                        handleView={handlePension}
                        autoComplete="contributionCompany" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>


                </Box>
                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Fringe Benefit </Typography></Box>
                </Box>


                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>

                    <Typography sx={style.inputText}>Fringe Benefit</Typography>
                    {data?.isShowEmpty || data?.totalFringe !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="fringeBenefit"
                        error={fringeBenefit?.error}
                        name="fringeBenefit"
                        onChange={handleChange}
                        buttonText="View"
                        handleView={handleFringe}

                        onFocus={handleFocus}
                        defaultValue={data?.totalFringe || 0}
                        readOnly={true}

                        autoComplete="fringeBenefit" />

                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>


                </Box>

                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Levies</Typography></Box>
                </Box>


                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Employer Levies</Typography>
                    {data?.isShowEmpty || data?.totalLevie !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="employerLevies"
                        error={employerLevies?.error}
                        name="employerLevies"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        buttonText="View"
                        readOnly={true}
                        handleView={handleLevie}

                        defaultValue={data?.totalLevie || 0}

                        autoComplete="employerLevies" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>


                </Box>

                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Leave</Typography></Box>
                </Box>


                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Leave</Typography>
                    {data?.isShowEmpty || data?.totalLeave !== 0 ? (

                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="leave"
                        error={leave?.error}
                        name="leave"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        buttonText="View"
                        defaultValue={data?.totalLeave || 0}
                        readOnly={true}
                        handleView={handleLeave}

                        autoComplete="leave" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}

                  </Box>
                </Box>


              </Grid>


            </Grid>
          </Grid>


        </Grid>

        <Box sx={style.mainBoxes}>
          <Box sx={style.createJob}>
            <LoadingButton loading={loading} disabled={edit === false} variant="contained" type="submit" color="success" sx={style.jobButtons} >
              Save
            </LoadingButton>
          </Box>
          <Box sx={style.createJob}>
            <Button variant="contained" sx={style.cancelButtons}>
              Cancel
            </Button>
          </Box>

        </Box>
      </form>

      <Modal open={pensionOpen} setOpen={setPensionOpen} title={"Contribution"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Contribution Type</TableCell>
                  <TableCell sx={style.TableHead}>Employee RateValue</TableCell>
                  <TableCell sx={style.TableHead}>Employer RateValue</TableCell>



                </TableRow>
              </TableHead>
              <TableBody>
                {contribution?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (


                  contribution?.map((item, index) => (

                    <TableRow key={index}>
                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.employeeCont?.rateValue}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.employerCont?.rateValue}</TableCell>
                    </TableRow>
                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={allowanceOpen} setOpen={setAllowanceOpen} title={"Allowance"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Amount</TableCell>



                </TableRow>
              </TableHead>
              <TableBody>
                {allowanceData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (


                  allowanceData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.rateValue}</TableCell>




                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={levieOpen} setOpen={setLevieOpen} title={"Levie"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Amount</TableCell>



                </TableRow>
              </TableHead>
              <TableBody>
                {levieData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (



                  levieData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.rateValue}</TableCell>




                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={fringeOpen} setOpen={setFringeOpen} title={"Fringe"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Employer fringe</TableCell>
                  <TableCell sx={style.TableHead}>Employee fringe</TableCell>



                </TableRow>

              </TableHead>
              <TableBody>
                {fringeData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (

                  fringeData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.employerCont?.totalAmount}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.employeeCont?.totalAmount}</TableCell>




                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={loanOpen} setOpen={setLoanOpen} title={"Loan Repayment"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Loan Amount</TableCell>
                  <TableCell sx={style.TableHead}>Repayment Amount</TableCell>
                  <TableCell sx={style.TableHead}>Pay Amount</TableCell>




                </TableRow>

              </TableHead>
              <TableBody>
                {loanData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (

                  loanData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.loanAmt}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.repayAmt}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.payAmount}</TableCell>





                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={deductionOpen} setOpen={setDeductionOpen} title={"All Deductions"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Amount</TableCell>




                </TableRow>

              </TableHead>
              <TableBody>
                {deductionData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  deductionData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.rateValue}</TableCell>






                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>

      <Modal open={leaveOpen} setOpen={setLeaveOpen} title={"Leave"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Leave Type</TableCell>
                  <TableCell sx={style.TableHead}>Leave From</TableCell>
                  <TableCell sx={style.TableHead}>Leave To</TableCell>




                </TableRow>
              </TableHead>
              <TableBody>
                {leaveData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (

                  leaveData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.leaveType}</TableCell>
                      <TableCell sx={style.tabledata}>{formatDate(item?.leaveFrom)}</TableCell>
                      <TableCell sx={style.tabledata}>{formatDate(item?.leaveTo)}</TableCell>





                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>

    </>
  )
}
export default SalaryEdit;

